import { render, staticRenderFns } from "./writeOffDetail.vue?vue&type=template&id=2c95f84c&scoped=true&"
import script from "./writeOffDetail.vue?vue&type=script&lang=js&"
export * from "./writeOffDetail.vue?vue&type=script&lang=js&"
import style0 from "./writeOffDetail.vue?vue&type=style&index=0&id=2c95f84c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95f84c",
  null
  
)

export default component.exports